export const nodeDefaults = {
  fileNode: { data: { protocol: 'SFTP', sort_order: 'ASCENDING', file_operation: 'MOVE', port:22} },
  apiNode: { data: { method: 'GET'} },
  taskServiceNode: { data: { assigned_user: '', assigned_group:'', task_type: 'manual', unit: 'hours', priority:'low'} },
  manualTaskNode: {
    data: {
      instructions: null,
      ai_recommendation: null,
      in_detail_entities: null,
      error_code_block: null,
      assignment: null,
      ai_intelligence_panel: null,
    },
  },
  timerNode: {data: {timer_unit:'minute'}},
  plannerNode: { data: { planner_cd: '', query_code_block: { lang: 'python', code_block: '' }, output_schema: null } },
  entityOperationNode: {
    data: {
      entity_cd: '',
      entity_operation: 'save'
      
    },
  },
  documentNode: {
    data: {
      documents: [{ 
        template_cd: '', 
        output_filename: 'document.pdf', 
        from_type: 'html', 
        to_type: 'pdf', 
        document_input_code_block: {
          lang: 'python',
          code_block: `# Ensure request is a dictionary (handles cases where it's None or empty)\nrequest_dict = request if isinstance(request, dict) else {}\n\n# Add the values that you want to use in the document.\n# All fields in \`input_to_document\` will be available as variables in the template\n# and their values will be replaced during document generation.\n# Example: The key below will override the value of the \`instructions\` variable in the template.\ninput_to_document = {\n    **request_dict,\n    # "instructions": "this is for test",\n}`
        } 
      }],
      template_cd: '',
      template_cd_code_block: null,
      output_filename: 'document.pdf',
      output_filename_code_block: null,
      document_response_code_block: {
        lang: 'python',
        code_block: `# response: represents the final payload returned by this node.\n# document_output: a list of dictionaries containing metadata of the generated documents.\n# Example format of document_output:\n# [\n#     {\n#         "file_url": "/files/a8b2984a-3fb9-4c8d-8e42-1e9bf8c8e1f5.pdf",\n#         "file_name": "document.pdf",\n#         "success": True\n#     }\n# ]\n\nresponse = document_output\nworkflow_vars['document_response'] = document_output`
      }
    }
  }
};

export const mandatoryFields = {
    fileNode: ['server_host']
}

export const convertNodeNameToLocal = (nodeName) => {
  switch (nodeName) {
    case 'triggerNode':
      return 'Trigger Node';
    case 'outputNode':
      return 'Output Node';
    case 'agentNode':
      return 'Agent Node';
    case 'modelNode':
      return 'Model Node';
    case 'knowledgeNode':
      return 'Knowledge Node';
    case 'dataSourceNode':
      return 'Data Source Node';
    case 'apiNode':
      return 'API Node';
    case 'taskServiceNode':
      return 'Task Service Node';
    case 'manualTaskNode':
      return 'Manual Task Node';
    case 'timerNode':
      return 'Timer Node';
    case 'classifierNode':
      return 'Classifier Node';
    case 'emailOutNode':
      return 'Email Out Node';
    case 'documentNode':
      return 'Document conversion';
    case 'codeNode':
      return 'Code Node';
    case 'webHookNode':
      return 'Web Hook Node';
    case 'toolNode':
      return 'Tool Node';
    case 'fileNode':
      return 'File Node';
    case 'plannerNode':
      return 'Planner Node';
    case 'entityOperationNode':
      return 'Entity Operation Node';
    default:
      return nodeName; 
  }
};
